<template>
    <div class="shop-item">
        <div class="goods-item" v-for="(item, index) in list" :key="index">
            <router-link :to="getRoute(item)">
                <div class="cover">
                    <el-image
                            :src="item.commodityImage"
                            fit="cover"/>
                </div>
                <div class="title">{{item.commodityName}}</div>
                <div class="fee">
                    <template  v-if="item.commodityPrice!==''">${{item.commodityPrice}}</template>
                </div>
            </router-link>
        </div>
    </div>
</template>

<script>
    export default {
        name: "CommodityItem",
        //type 有 "brand", "store" 兩種，都是string
        props: ['list', 'type' , 'routerName'],
        data() {
            return {
            }
        },
        created() {
        },
        mounted() {

        },
        methods: {

            /** 點擊更多商品 */
            getRoute: function (item) {
                if (this.$public.notNull(this.routerName) && this.routerName === "Product") {
                    let dataToken = this.cryptDataToken({"itemId": item.commodityId, "shopAreaId": item.shopAreaId});
                    return {name: 'Product', query: {"dataToken": dataToken}};
                } else {
                    return {name: this.routerName ,query:{mealId:item.commodityId ,type : this.type}};
                }

            },

            /** 組裝 dataToken */
            cryptDataToken: function(item) {
                return this.$crypto.objectToURIComponent(item) ;
            },

            /** 解析 dataToken */
            decryptDataToken: function(item) {
                return this.$crypto.uriComponentToObject(item);
            },
        }
    }
</script>

<style lang="less" scoped>
    .shop-item{
        @media(min-width: 1024px){
            margin: 5px -20px 0;
        }
    }
    .red{
        min-height: 40px;
    }
</style>